import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useLayout } from "@/contexts/LayoutContext";
import { useQuickTask } from "@/contexts/QuickTaskContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/shadcn/dropdown-menu";
import { HeaderTip } from "./HeaderTip";

export const buildAddTaskUrl = () =>
  `/AddTask.aspx?location=${encodeURIComponent(window.location.pathname + window.location.search)}&`;

export const NewTaskButton = () => {
  const { data } = useLayout();
  const { openQuickTask } = useQuickTask();
  const addTaskUrl = buildAddTaskUrl;

  const isQuickDefault = data.newTaskDefaultFull !== true;
  return (
    <div className="flex items-center group">
      {isQuickDefault ? (
        <button
          type="button"
          onClick={openQuickTask}
          aria-label="New Task"
          className="flex items-center gap-1 px-3 h-9 text-sm font-medium text-white bg-(--layout-brand) hover:bg-(--layout-brand-hover) transition-colors cursor-pointer border border-white/40 group-hover:border-white rounded-l-[6px] border-r-0 outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:z-10"
        >
          <FontAwesomeIcon icon={faPlus} size="sm" />
          <span className="hidden lg:inline">New Task</span>
        </button>
      ) : (
        <a
          href={addTaskUrl()}
          aria-label="New Task"
          className="flex items-center gap-1 px-3 h-9 text-sm font-medium text-white bg-(--layout-brand) hover:bg-(--layout-brand-hover) transition-colors cursor-pointer border border-white/40 group-hover:border-white rounded-l-[6px] border-r-0 outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:z-10"
        >
          <FontAwesomeIcon icon={faPlus} size="sm" />
          <span className="hidden lg:inline">New Task</span>
        </a>
      )}

      <DropdownMenu>
        <HeaderTip label="More task options">
        <DropdownMenuTrigger asChild>
          <button
            className="flex items-center justify-center w-7 h-9 text-white bg-(--layout-brand) hover:bg-(--layout-brand-hover) transition-colors border border-white/40 group-hover:border-white rounded-r-[6px] outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:z-10"
            aria-label="More task options"
          >
            <FontAwesomeIcon icon={faChevronDown} size="xs" />
          </button>
        </DropdownMenuTrigger>
        </HeaderTip>
        <DropdownMenuContent align="start" className="min-w-40">
          <NewTaskMenuItems />
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}

export const NewTaskMenuItems = () => {
  const { data } = useLayout();
  const { openQuickTask } = useQuickTask();

  return (
    <>
      <DropdownMenuItem onSelect={openQuickTask}>
        Quick Task
      </DropdownMenuItem>
      <DropdownMenuItem asChild>
        <a href={buildAddTaskUrl()}>Full Task</a>
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild>
        <a href={data.appRoutes.addProspect}>New Prospect</a>
      </DropdownMenuItem>
    </>
  );
}
